import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function CardCarousel() {
  const slides = [
    {
      id: 1,
      title: "– Dan",
      desc: "Lovely to deal with and did a great job with my puppy. Highly recommend. Easy parking.",
      img: "/assets/images/animal.jpg",
      bgColor: "#D9F9E7",
    },
    {
      id: 2,
      title: "– Mike",
      desc: "Brilliant service. Rhylee has looked after our Cavoodle since he was a puppy and has always provided a great cut.",
      img: "/assets/images/image5.jpg",
      bgColor: "#FFE7B9",
    },
    {
      id: 3,
      title: "– Leanne",
      desc: "Our mini Schnauzer “Luci” loves going to doggy daycare once a week. We also have her groomed at Furlissimo without any problem. Very happy with the service.",
      img: "/assets/images/image6.jpg",
      bgColor: "#E0F3FF",
    },
  ];

  // Komponen kecil untuk text dengan read more
  const TruncatedText = ({ text, maxLength = 100 }) => {
    const [expanded, setExpanded] = React.useState(false);
    const shouldTruncate = text.length > maxLength;
    const displayText = expanded
      ? text
      : text.slice(0, maxLength) + (shouldTruncate ? "..." : "");

    return (
      <>
        <p className="text-gray-600 text-sm md:text-base mb-4 leading-relaxed">
          “{displayText}”
        </p>
        {shouldTruncate && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-teal-600 text-sm font-semibold hover:underline focus:outline-none"
          >
            {expanded ? "Read less" : "Read more"}
          </button>
        )}
      </>
    );
  };

  return (
    <section
      className="w-full py-20 px-8 md:px-16 bg-[#F9FAFB]"
      style={{
        backgroundImage: `url('/assets/images/bg4.jpg')`,
        backgroundSize: "cover", // agar gambar menutupi seluruh area
        backgroundPosition: "center", // agar posisi gambar rapi di tengah
        backgroundRepeat: "no-repeat", // agar tidak diulang
      }}
    >
      {/* Judul */}
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
          Our Grooming Services
        </h2>
        <p className="text-gray-600 mt-2">
          Choose from our professional grooming options — your pet deserves the
          best!
        </p>
      </div>

      {/* Swiper Carousel */}
      <div className="max-w-7xl mx-auto">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          spaceBetween={30}
          centeredSlides={true}
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="bg-white rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 flex flex-col md:flex-row items-center overflow-hidden h-full">
                {/* Gambar kiri */}
                <div
                  className="md:w-1/2 w-full h-56 md:h-64 flex items-center justify-center"
                  style={{ backgroundColor: slide.bgColor }}
                >
                  <img
                    src={slide.img}
                    alt={slide.title}
                    className="w-full h-full object-cover rounded-none md:rounded-l-3xl transition-transform duration-500 hover:scale-105"
                  />
                </div>

                {/* Teks kanan */}
                <div className="md:w-1/2 w-full p-8 text-center md:text-left flex flex-col justify-center">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                    {slide.title}
                  </h3>

                  <div className="flex justify-center md:justify-start mb-3">
                    <i className="fa-solid fa-star text-yellow-400 mr-1"></i>
                    <i className="fa-solid fa-star text-yellow-400 mr-1"></i>
                    <i className="fa-solid fa-star text-yellow-400 mr-1"></i>
                    <i className="fa-solid fa-star text-yellow-400 mr-1"></i>
                    <i className="fa-solid fa-star text-yellow-400"></i>
                  </div>
                  
                  <TruncatedText text={slide.desc} />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
